"use strict";

require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInstall = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-param-reassign */

var difference_1 = tslib_1.__importDefault(require("lodash-es/difference"));
var directive_1 = require("./directive");
var version_1 = require("./version");
function createInstall(install, target) {
  return function (vueApp) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!(0, version_1.isVue3)(vueApp)) {
      return install.call.apply(install, [this, vueApp].concat(args));
    }
    if (target === null || target === void 0 ? void 0 : target.directives) {
      target.directives = (0, directive_1.createDirectives)(target.directives, vueApp);
    }
    if (!vueApp.prototype) {
      vueApp.prototype = {};
    }
    var originMethods = Object.keys(vueApp.prototype);
    install.call.apply(install, [this, vueApp].concat(args));
    var installedMethods = (0, difference_1.default)(Object.keys(vueApp.prototype), originMethods);
    installedMethods.forEach(function (method) {
      vueApp.config.globalProperties[method] = vueApp.prototype[method];
    });
    if (!(0, version_1.hasVueApp)() && (target === null || target === void 0 ? void 0 : target.directives)) {
      target.directives = (0, directive_1.createDirectives)(target.directives, vueApp);
    }
  };
}
exports.createInstall = createInstall;